import type { ProductCategory } from '@product-updates/shared-types';

export const PRODUCT_MAP: Record<string, ProductCategory> = {
  hire: 'Hire',
  manage: 'Manage',
  grow: 'Grow',
  ai: 'AI',
};
